import React from 'react';

export const TwitterIcon = (props: any) => (
  <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.303 10.7714L19.1223 4H17.7433L12.6904 9.87954L8.65471 4H4L10.1028 12.8909L4 19.9918H5.37906L10.715 13.7828L14.977 19.9918H19.6317L13.3027 10.7714H13.303ZM11.4142 12.9692L10.7958 12.0839L5.87595 5.03921H7.9941L11.9645 10.7245L12.5829 11.6098L17.7439 18.9998H15.6258L11.4142 12.9696V12.9692Z" />
  </svg>
);
